import React from 'react';
import '../styles/AboutUS.css';

const AboutUs = () => {

  const features = [
    {
      id: 1,
      icon: 'https://img.icons8.com/?size=100&id=ZbNOoXleVpQN&format=png&color=000000',
      description:
        'Manufacture defect free products.'
    },
    {
      id: 2,
      icon: 'https://img.icons8.com/?size=100&id=GaZyzpIg5O9B&format=png&color=000000',
      title: 'Secure',
      description: '  Solve the problem at the source.'
    },
    {
      id: 3,
      icon: 'https://img.icons8.com/?size=100&id=26293&format=png&color=000000',
      title: 'Unmatched Product Excellence',
      description:
        'Stringent quality systems implemented across the organisation. ' 
      },
    {
      id: 4,
      icon: 'https://img.icons8.com/?size=100&id=6WQkdoAdssl3&format=png&color=000000',
      title: 'Unmatched Product Excellence',
      description:
        'Trained and highly motivated manpower.'
    },
    {
      id: 5,
      icon: 'https://img.icons8.com/?size=100&id=AqNO4MjBnpdm&format=png&color=000000',
      title: 'Unmatched Product Excellence',
      description:
        ' Machinery with latest technology. '
    },
    {
      id: 6,
      icon: 'https://img.icons8.com/?size=100&id=hqE7Nhimn8FF&format=png&color=000000',
      title: 'Unmatched Product Excellence',
      description:
        ' Use of proper inspection and testing methods.'
    },
    {
      id: 7,
      icon: 'https://img.icons8.com/?size=100&id=Hku9UaGJ7edj&format=png&color=000000',
      title: 'Unmatched Product Excellence',
      description:
        ' Well documented procedures.'
    }
  ];


  return (
    <section className="about-us">
      {/* Hero Section */}
      <div className="about-hero">
        <h1>About Us</h1>
      </div>

      {/* Content Section with Two Columns */}
      <div className="about-container">
        {/* Left Side: Description */}
        <div className="about-left">
          <h2 style={{color:'#0094f6'}}>Who We Are</h2><br/>
          <p>
            Sujay Industries is a leader in the manufacturing industry, combining cutting-edge technology, craftsmanship, and a dedication to excellence. Our focus is on delivering high-quality products that drive customer satisfaction and long-term success.
          </p><br/>
          <p>
          Sujay Industries is a dynamic and innovative company dedicated to delivering high-quality products and solutions across a range of industries. 
          Established in [founding year], Sujay Industries has rapidly grown into a trusted name, known for its commitment to excellence, customer satisfaction, 
          and continuous innovation. With a focus on cutting-edge technology and sustainable practices, we strive to meet the evolving needs of our clients while maintaining the highest standards of quality and service. Our diverse portfolio and skilled team allow us to serve customers worldwide,
           making Sujay Industries a preferred partner in your industry or industries
          </p>
        </div>

        {/* Right Side: Image */}
        <div className="about-right">
          <img
            src="https://img.freepik.com/premium-photo/aerial-view-cement-factory-with-high-concrete-structure-tower-crane-industrial-production-area-manufacture-global-industry-concept_127089-13588.jpg?w=1060"
            alt="Sujay Industries"
            className="about-image"
          />
        </div>
      </div>

      {/* Vision, Mission, and Quality Section */}
      <div className="about-cards">
        <div className="about-card">
          <img
            src="https://img.freepik.com/free-vector/business-vision-concept-illustration_114360-7130.jpg"
            alt="Vision"
          />
          <h2>Vision</h2><br/>
          <p>
            To be a global leader in manufacturing, setting standards for innovation, quality, and sustainable practices.
          </p>
        </div>

        <div className="about-card">
          <img
            src="https://img.freepik.com/free-vector/goal-achievement-teamwork-business-concept_107791-29.jpg"
            alt="Mission"
          />
          <h2>Mission</h2><br/>
          <p>
            To deliver superior products and services that meet the evolving needs of our clients.
          </p>
        </div>

        <div className="about-card">
          <img
            src="https://img.freepik.com/premium-vector/hundred-percent-quality-tag-label-icon_192037-2933.jpg"
            alt="Quality"
          />
          <h2 style={{color:'#0094f6'}}>Quality Assurance</h2><br/>
          <p>
            We uphold rigorous quality standards at every stage of production.
          </p>
        </div>
      </div>

     

     


<div className="quality-container">
        {/* Left side: Image */}
        <div className="quality-image">
          <img
            src="https://img.freepik.com/premium-vector/quality-profitability-lower-cost-business-strategy-financial-analytics-increasing-profit-sales-manager-accounting-promotion-operations-concept-businessman-manages-financial-growth_273625-2621.jpg?w=740"
            alt="Features"
          />
        </div>

        {/* Right side: Features List */}
        <div className="quality-content">
          <div className="quality-grid">
            <h2 style={{color:"blue"}}>Quality Foundation</h2>
            {features.map((feature) => (
              <div key={feature.id} className="quality-card">
                <img src={feature.icon} alt={feature.title} className="quality-icon"></img>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* New Section: Image on the Left, Text on the Right */}
<div className="about-extra-section">
  {/* Left Side: Image */}
  <div className="extra-image-container">
    <img
      src={require('../assets/corebiusness.avif')}
      alt="State-of-the-Art Machinery"
      className="extra-image"
    />
  </div>

  {/* Right Side: Text Description */}
  <div className="extra-description">
    <h2>Core Business Area</h2>
    <ul>
      <li>Manufacture of precision turned and milled 
      components.</li>
      <li>Auto parts</li>
      <li> Hydraulic , General Engineering and electrical.</li>
      <li>Assemblies and Sub Assemblies</li>
      <li>Machined parts</li>
    </ul>
  </div>
</div>



    </section>
  );
};

export default AboutUs;
